'use client'
import { createContext } from 'react'
import type { BrandsContextType } from './types'

export const BrandsContext = createContext<BrandsContextType | null>(null)
